import React, { Component } from 'react';
import { connect } from 'react-redux';

import ShowForPermission from '../../components/ShowForPermission';
import CheckoutReserveDetails from './checkoutDetails';
import FinalCheckout from './finalCheckout';
import Spin from '../../components/loading';

import ENUMS from '../../enums';
import { formatter, enumHelper } from '../../utils';
import generateClassName from '../../utils/generateClassName';

import './styles.scss';

class CheckoutTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chekoutDetailsOpen: false,
      finalCheckoutOpen: false,
      selectedCheckoutId: -1,
      sortedColumn: ''
    };
  }

  closeCheckoutModal = () => {
    this.setState(() => ({
      chekoutDetailsOpen: false
    }));
  };

  closeFinalCheckoutModal = () => {
    this.setState(() => ({
      finalCheckoutOpen: false
    }));
  };

  displayCheckoutDetailsModal = id => {
    let { checkoutOrClientAbsentReservesList = [] } = this.props;
    let selectedCheckoutId = checkoutOrClientAbsentReservesList.filter(payment => payment.id == id)[0].id;
    this.setState({ chekoutDetailsOpen: true, selectedCheckoutId });
  };

  displayFinalCheckoutModal = id => {
    let { checkoutOrClientAbsentReservesList = [] } = this.props;
    let selectedCheckoutId = checkoutOrClientAbsentReservesList.filter(payment => payment.id == id)[0].id;
    this.setState({ finalCheckoutOpen: true, selectedCheckoutId });
  };

  sortTable = query => {
    this.setState({ sortedColumn: query });
    this.props.sortTable(query);
  };

  totalStatus = (list, cafeAdmin) => {
    const totalAmount = this.totalAmount(list);
    return enumHelper.convertEnumValueToTitle(
      ENUMS.CHECKOUT_TYPES.list,
      totalAmount > 0
        ? cafeAdmin
          ? 'CREDITOR'
          : 'DEBTOR'
        : totalAmount < 0
        ? cafeAdmin
          ? 'DEBTOR'
          : 'CREDITOR'
        : 'NOTHING'
    );
  };

  totalAmount = list => {
    return list && list.length ? list[0].totalAmount : 0;
  };

  render() {
    let {
      checkoutOrClientAbsentReservesList = [],
      pageNumber,
      pageSize,
      loading,
      failed,
      error,
      message,
      sortType
    } = this.props;
    return (
      <>
        <Spin spinning={loading}>
          {error && <div className="alert alert-danger">{locales('messages.server.error')}</div>}
          {failed && <div className="alert alert-danger">{message}</div>}
          <div className="table-responsive">
            <table className="table table-hover table-bordered table-striped my-2">
              <thead className="thead-dark">
                <tr>
                  <th className="text-center"></th>
                  <ShowForPermission
                    permission={ENUMS.PERMISSIONS.values.VIEW_CHECKOUTS_WITH_CAFE_LIST_FOR_ADMIN}
                  >
                    <th onClick={() => this.sortTable('cafeName')} className="text-center pointer">
                      <i
                        name="cafeName"
                        className={generateClassName('name', this.state.sortedColumn, sortType)}
                      />
                      {locales('fields.cafe.name')}
                    </th>
                  </ShowForPermission>
                  <th onClick={() => this.sortTable('createdAt')} className="text-center pointer">
                    <i
                      name="createdAt"
                      className={generateClassName('createdAt', this.state.sortedColumn, sortType)}
                    />
                    {locales('tables.creationDate')}
                  </th>
                  <th onClick={() => this.sortTable('fromDate')} className="text-center pointer">
                    <i
                      name="fromDate"
                      className={generateClassName('fromDate', this.state.sortedColumn, sortType)}
                    />
                    {locales('labels.from.date')}
                  </th>
                  <th onClick={() => this.sortTable('toDate')} className="text-center pointer">
                    <i
                      name="toDate"
                      className={generateClassName('toDate', this.state.sortedColumn, sortType)}
                    />
                    {locales('labels.to.date')}
                  </th>
                  <th onClick={() => this.sortTable('reservesCount')} className="text-center pointer">
                    <i
                      name="reservesCount"
                      className={generateClassName('reservesCount', this.state.sortedColumn, sortType)}
                    />
                    {locales('labels.reservesCount')}
                  </th>
                  <th onClick={() => this.sortTable('amount')} className="text-center pointer">
                    <i
                      name="amount"
                      className={generateClassName('amount', this.state.sortedColumn, sortType)}
                    />
                    {locales('tables.amount')}
                  </th>
                  <th className="text-center">{locales('tables.status')}</th>
                  <ShowForPermission
                    permission={ENUMS.PERMISSIONS.values.VIEW_CHECKOUTS_WITH_CAFE_LIST_FOR_ADMIN}
                  >
                    <th></th>
                    <th></th>
                  </ShowForPermission>
                </tr>
              </thead>
              <tbody>
                {checkoutOrClientAbsentReservesList.length ? (
                  checkoutOrClientAbsentReservesList.map((item, index) => (
                    <tr key={item.id}>
                      <td className="text-center">{(pageNumber - 1) * pageSize + index + 1}</td>
                      {/* <td className="text-center">{index + 1}</td> */}
                      <ShowForPermission
                        permission={ENUMS.PERMISSIONS.values.VIEW_CHECKOUTS_WITH_CAFE_LIST_FOR_ADMIN}
                      >
                        <td className="text-center">{item.cafeName || '---'}</td>
                      </ShowForPermission>
                      <td className="text-center">{item.createdAt || '---'}</td>
                      <td className="text-center">{item.fromDate || '---'}</td>
                      <td className="text-center">{item.toDate || '---'}</td>
                      <td className="text-center">{item.reservesCount || '---'}</td>
                      <ShowForPermission
                        permission={ENUMS.PERMISSIONS.values.VIEW_CHECKOUTS_WITH_CAFE_LIST_FOR_ADMIN}
                      >
                        <td className="text-center" dir="ltr">
                          <strong
                            className={`text-${
                              item.amount > 0
                                ? 'danger'
                                : item.amount < 0 && !item.isCheckout
                                ? 'warning'
                                : 'success'
                            }`}
                          >
                            {`${item.amount > 0 ? '+' : ''}${formatter.numberWithCommas(item.amount)}`}
                          </strong>
                        </td>
                        <td className="text-center">
                          <strong
                            className={`badge badge-${
                              item.amount > 0
                                ? 'danger'
                                : item.amount < 0 && !item.isCheckout
                                ? 'warning'
                                : 'success'
                            }`}
                          >
                            {item.status}
                          </strong>
                        </td>
                      </ShowForPermission>
                      <ShowForPermission
                        permission={ENUMS.PERMISSIONS.values.VIEW_CHECKOUTS_WITH_CAFE_LIST_FOR_CAFE_ADMIN}
                      >
                        <td className="text-center">
                          <strong className="text-success" dir="ltr">
                            {`+${formatter.numberWithCommas(Math.abs(item.amount))}`}
                          </strong>
                        </td>
                        <td className="text-center">
                          <strong className="badge badge-success">{item.status}</strong>
                        </td>
                      </ShowForPermission>
                      <ShowForPermission
                        permission={ENUMS.PERMISSIONS.values.VIEW_CHECKOUTS_WITH_CAFE_LIST_FOR_ADMIN}
                      >
                        <td className="text-center">
                          <button
                            type="button"
                            onClick={() => this.displayFinalCheckoutModal(item.id)}
                            className="btn btn-sm btn-primary"
                            disabled={item.isCheckout}
                          >
                            {locales('titles.checkout')}
                          </button>
                        </td>
                      </ShowForPermission>
                      <ShowForPermission
                        permission={ENUMS.PERMISSIONS.values.VIEW_CHECKOUTS_WITH_CAFE_LIST_FOR_ADMIN}
                      >
                        <td className="text-center">
                          <i
                            onClick={() => this.displayCheckoutDetailsModal(item.id)}
                            className="far fa-info-circle pointer"
                            title={locales('titles.details')}
                          />
                        </td>
                      </ShowForPermission>
                    </tr>
                  ))
                ) : (
                  <tr className="col-12 text-center">
                    <td className="alert alert-info" colSpan={14}>
                      {locales('alerts.noRecord')}
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot className="thead-dark">
                <tr>
                  <td colSpan="10"></td>
                </tr>
                <ShowForPermission
                  permission={ENUMS.PERMISSIONS.values.VIEW_CHECKOUTS_WITH_CAFE_LIST_FOR_ADMIN}
                >
                  <tr>
                    <th colSpan="3"></th>
                    <th className="text-left">{locales('tables.status')}</th>
                    <th className="text-center" colSpan="2">
                      {
                        <strong
                          className={`badge badge-${
                            this.totalAmount(checkoutOrClientAbsentReservesList) > 0
                              ? 'danger'
                              : this.totalAmount(checkoutOrClientAbsentReservesList) === 0
                              ? 'success'
                              : 'warning'
                          }`}
                        >
                          {this.totalStatus(checkoutOrClientAbsentReservesList, false)}
                        </strong>
                      }
                    </th>
                    <th colSpan="4"></th>
                  </tr>
                </ShowForPermission>
                <tr>
                  <th colSpan="3"></th>
                  <th className="text-left">{locales('tables.amount')}</th>
                  <th className="text-center" dir="ltr" colSpan="2">
                    <ShowForPermission
                      permission={ENUMS.PERMISSIONS.values.VIEW_CHECKOUTS_WITH_CAFE_LIST_FOR_ADMIN}
                    >
                      {
                        <strong
                          className={`text-${
                            this.totalAmount(checkoutOrClientAbsentReservesList) > 0
                              ? 'danger'
                              : this.totalAmount(checkoutOrClientAbsentReservesList) === 0
                              ? 'success'
                              : 'warning'
                          }`}
                        >
                          {`${
                            this.totalAmount(checkoutOrClientAbsentReservesList) > 0 ? '+' : ''
                          }${formatter.numberWithCommas(
                            this.totalAmount(checkoutOrClientAbsentReservesList)
                          )}`}
                        </strong>
                      }
                    </ShowForPermission>

                    <ShowForPermission
                      permission={ENUMS.PERMISSIONS.values.VIEW_CHECKOUTS_WITH_CAFE_LIST_FOR_CAFE_ADMIN}
                    >
                      {
                        <strong className="text-success">
                          {`+${Math.abs(this.totalAmount(checkoutOrClientAbsentReservesList))}`}
                        </strong>
                      }
                    </ShowForPermission>
                  </th>
                  <th colSpan="4"></th>
                </tr>
              </tfoot>
            </table>
          </div>

          {this.state.chekoutDetailsOpen && (
            <CheckoutReserveDetails
              isOpen={this.state.chekoutDetailsOpen}
              checkoutId={this.state.selectedCheckoutId}
              closeModal={this.closeCheckoutModal}
            />
          )}
          {this.state.finalCheckoutOpen && (
            <FinalCheckout
              isOpen={this.state.finalCheckoutOpen}
              checkoutId={this.state.selectedCheckoutId}
              closeModal={this.closeFinalCheckoutModal}
            />
          )}
        </Spin>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    checkoutOrClientAbsentReservesList: state.reservationsReducer.checkoutOrClientAbsentReservesList
  };
};

export default connect(mapStateToProps)(CheckoutTable);
